import { StatusStyleCode } from '../common'
import { IApiUserAccount } from '../tap-api/user-service.types'

export type PublishedError = {
    op: string,
    ca: number,
    cf: number,
    restFact: number,
    restAssigned: number,
    materialName: string,
    mc: string,
    opName: string,
}

export type ProductionInventory = {
    id: number,
    planId: number,
    versionId: number,
    createdAt: Date,
    createdOn: Date,
    createdBy: number,
    updatedAt?: Date,
    updatedBy?: number,
    publishedAt?: Date,
    publishedOn?: Date,
    publishedBy?: number,
    isPublished: boolean,
    status: ProductionInventoryStatusCode,
    desctiption?: string,
    rawData: {
        inventory: ProductionInventoryRawData[],
    },
    description?: string,
    type: ProductionInventoryType,
    files: ProductionInventoryUploadedFile[],
    errors: PublishedError[] | null,
}

export type ProductionInventoryUploadedFile = {
    name: string,
    status: string,
    uploadedAt: string,
    uploadedBy: IApiUserAccount,
}

export type ProductionInventoryRawData = {
    o: string,
    d: string,
    n: string,
    mu: string,

    rc?: string,
    rp?: string,
    t: ProductionInventoryItemType,
    c: number,
    dc?: number,
    ms?: string,
    s?: number,
}

export enum ProductionInventoryType {
    ShiftTask = 'shift-task',
    Stage = 'stage',
}

export const ProductionInventoryTypeObj: { [key in ProductionInventoryType]: Omit<TypeSpec, 'code'> } = {
    [ProductionInventoryType.ShiftTask]: { name: 'По заданиям' },
    [ProductionInventoryType.Stage]: { name: 'По переделам' },
}

export const ProductionInventoryTypeList: TypeSpec[] = Object.keys(ProductionInventoryTypeObj).map(code => ({
    ...ProductionInventoryTypeObj[code as keyof typeof ProductionInventoryTypeObj],
    code: code as ProductionInventoryType,
}));

export type ProductionInventoryParams = {
    planId: number,
    versionId: number,
    createdOn: number,
    type: ProductionInventoryType,
}

type TypeSpec = {
    code: string,
    name: string,
}

export enum ProductionInventoryItemType {
    Stage = 'stage',
    End = 'end',
    Ready = 'ready',
    Defect = 'defect',
}

export enum ProductionInventoryStatusCode {
    New = 'new',
    Published = 'published',
    Updated = 'updated',
}

export const ProductionInventoryStatusObj: { [key in ProductionInventoryStatusCode]: Omit<TypeSpec, 'code'> } = {
    [ProductionInventoryStatusCode.New]: { name: 'Новое' },
    [ProductionInventoryStatusCode.Published]: { name: 'Опубликовано' },
    [ProductionInventoryStatusCode.Updated]: { name: 'Отредактировано' },
}

export const getStatusColor = (status: ProductionInventoryStatusCode) => {
    if (status === ProductionInventoryStatusCode.New)
        return StatusStyleCode.Blue;

    if (status === ProductionInventoryStatusCode.Updated)
        return StatusStyleCode.Yellow;

    if (status === ProductionInventoryStatusCode.Published)
        return StatusStyleCode.Green;

    return StatusStyleCode.Gray;
}